import * as React from 'react';
import { SVGProps } from 'react';

const IconLockSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 10V7a5 5 0 0 1 10 0v3h3.75c.69 0 1.25.551 1.25 1.23v13.54c0 .679-.56 1.23-1.25 1.23H5.25A1.24 1.24 0 0 1 4 24.77V11.23c0-.679.56-1.23 1.25-1.23H9Zm2-3a3 3 0 1 1 6 0v3h-6V7Zm3.79 10.874a2.466 2.466 0 0 0 1.71-2.335c0-1.36-1.12-2.462-2.5-2.462s-2.5 1.102-2.5 2.462c0 1.087.716 2.01 1.71 2.335l-1.71 5.05h5l-1.71-5.05Z"
    />
  </svg>
);
export default IconLockSizeL;
